export default __webpack_public_path__ + "static/media/katsu.68da1535.png";